import { Injector } from '@angular/core';
import { LOCATION_INITIALIZED } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

export function appInitialiserFactory(translate: TranslateService, injector: Injector) {
  return () =>
    new Promise<void>((resolve) => {
      const locationInitialized = injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
      void locationInitialized.then(() => {
        const langToSet = 'en';
        translate.setDefaultLang('en');
        translate.use(langToSet).subscribe({
          error: () => {
            /* language initialisation failed — non-blocking */
          },
          complete: () => {
            resolve();
          },
        });
      });
    });
}
